var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", { staticClass: "fl-left avatar-box" }, [
              _c("div", { staticClass: "user-card" }, [
                _c(
                  "div",
                  {
                    staticClass: "user-headpic-update",
                    style: {
                      "background-image":
                        "url(" +
                        (_vm.userInfo.headerImg &&
                        _vm.userInfo.headerImg.slice(0, 4) !== "http"
                          ? _vm.path + _vm.userInfo.headerImg
                          : _vm.userInfo.headerImg) +
                        ")",
                      "background-repeat": "no-repeat",
                      "background-size": "cover",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "update",
                        on: { click: _vm.openChooseImg },
                      },
                      [
                        _c("i", { staticClass: "el-icon-edit" }),
                        _vm._v(" 重新上传"),
                      ]
                    ),
                  ]
                ),
                _c("div", { staticClass: "user-personality" }, [
                  _c("p", { staticClass: "nickname" }, [
                    _vm._v(_vm._s(_vm.userInfo.nickName)),
                  ]),
                  _c("p", { staticClass: "person-info" }, [
                    _vm._v("这个家伙很懒，什么都没有留下"),
                  ]),
                ]),
                _c("div", { staticClass: "user-information" }, [
                  _c(
                    "ul",
                    [
                      _c("li", [
                        _c("i", { staticClass: "el-icon-user" }),
                        _vm._v(_vm._s(_vm.userInfo.nickName) + " "),
                      ]),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "light",
                            content:
                              "北京反转极光科技有限公司-技术部-前端事业群",
                            placement: "top",
                          },
                        },
                        [
                          _c("li", [
                            _c("i", { staticClass: "el-icon-data-analysis" }),
                            _vm._v(
                              "北京反转极光科技有限公司-技术部-前端事业群 "
                            ),
                          ]),
                        ]
                      ),
                      _c("li", [
                        _c("i", { staticClass: "el-icon-video-camera-solid" }),
                        _vm._v("中国·北京市·朝阳区 "),
                      ]),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "light",
                            content: "goLang/JavaScript/Vue/Gorm",
                            placement: "top",
                          },
                        },
                        [
                          _c("li", [
                            _c("i", { staticClass: "el-icon-medal-1" }),
                            _vm._v("goLang/JavaScript/Vue/Gorm "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 18 } }, [
            _c(
              "div",
              { staticClass: "user-addcount" },
              [
                _c(
                  "el-tabs",
                  {
                    on: { "tab-click": _vm.handleClick },
                    model: {
                      value: _vm.activeName,
                      callback: function ($$v) {
                        _vm.activeName = $$v
                      },
                      expression: "activeName",
                    },
                  },
                  [
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "账号绑定", name: "second" } },
                      [
                        _c("ul", [
                          _c("li", [
                            _c("p", { staticClass: "title" }, [
                              _vm._v("密保手机"),
                            ]),
                            _c("p", { staticClass: "desc" }, [
                              _vm._v(" 已绑定手机:1245678910 "),
                              _c("a", { attrs: { href: "#" } }, [
                                _vm._v("立即修改"),
                              ]),
                            ]),
                          ]),
                          _c("li", [
                            _c("p", { staticClass: "title" }, [
                              _vm._v("密保邮箱"),
                            ]),
                            _c("p", { staticClass: "desc" }, [
                              _vm._v(" 已绑定邮箱：ColaPay@google.com.cn "),
                              _c("a", { attrs: { href: "#" } }, [
                                _vm._v("立即修改"),
                              ]),
                            ]),
                          ]),
                          _c("li", [
                            _c("p", { staticClass: "title" }, [
                              _vm._v("修改密码"),
                            ]),
                            _c("p", { staticClass: "desc" }, [
                              _vm._v(" 修改个人密码 "),
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showPassword = true
                                    },
                                  },
                                },
                                [_vm._v("修改密码")]
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("ChooseImg", { ref: "chooseImg", on: { "enter-img": _vm.enterImg } }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showPassword,
            title: "修改密码",
            width: "360px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showPassword = $event
            },
            close: _vm.clearPassword,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "modifyPwdForm",
              attrs: {
                model: _vm.pwdModify,
                rules: _vm.rules,
                "label-width": "80px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { minlength: 6, label: "原密码", prop: "password" } },
                [
                  _c("el-input", {
                    attrs: { "show-password": "" },
                    model: {
                      value: _vm.pwdModify.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.pwdModify, "password", $$v)
                      },
                      expression: "pwdModify.password",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { minlength: 6, label: "新密码", prop: "newPassword" },
                },
                [
                  _c("el-input", {
                    attrs: { "show-password": "" },
                    model: {
                      value: _vm.pwdModify.newPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.pwdModify, "newPassword", $$v)
                      },
                      expression: "pwdModify.newPassword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    minlength: 6,
                    label: "确认密码",
                    prop: "confirmPassword",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { "show-password": "" },
                    model: {
                      value: _vm.pwdModify.confirmPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.pwdModify, "confirmPassword", $$v)
                      },
                      expression: "pwdModify.confirmPassword",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showPassword = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.savePassword } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }